import IAuthorizationData from '../../../../vendor_core/core/src/server/data/IAuthorizationData';
import { IBaseDataParser } from '../../../../vendor_core/core/src/server/parsers/IBaseDataParser';

export default class BBConfigDataParser implements IBaseDataParser<IAuthorizationData> {
    public check(data: any): boolean {
        return data && data.config;
    }

    public parse(data: any): IAuthorizationData[] {

        const result: IAuthorizationData = {
            rtp: data.config.rtp
        };

        return [result];
    }
}
